"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _fluxActions = require("flux-actions");

var _ActionTypes = _interopRequireDefault(require("../constants/ActionTypes"));

var _default = (0, _fluxActions.createAction)(_ActionTypes.default.RESET_ALL_CHANGES);

exports.default = _default;
module.exports = exports.default;